import Portal from 'semantic-ui-react/dist/es/addons/Portal';

export default Portal;
